import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { ScheduleBadgeProps } from "./ScheduleBadge.types"

const icon = faIcon({ name: "calendar-lines", style: "regular" })

export default function ScheduleBadge(props: ScheduleBadgeProps) {
    const { date, size = "md", label = "Scheduled" } = props

    const { formatDatetime, formatDatetimeTooltip } = useDateFormatters()

    const text = formatDatetime(date)

    if (!text) {
        return null
    }

    // The schedule is a future moment, so the tooltip reads "Scheduled for …".
    const tooltip = formatDatetimeTooltip(label, date, true)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {text}
        </Badge>
    )
}
